import React from 'react';
export const GruserContext = /*#__PURE__*/ React.createContext({
    gruser: undefined,
    gruserOwner: undefined
});
GruserContext.displayName = 'GruserContext';
export default GruserContext;

//# sourceMappingURL=GruserContext.js.map